import { useHandler } from "@redotech/react-util/hook";
import { useTranslation } from "@redotech/redo-i18n";
import { FinalSaleReturnState } from "@redotech/redo-return-core-common/return-flow-step-valid";
import { StepTypeDetailsProps } from "@redotech/redo-return-ui/flows/step";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

export const FinalSaleReturnDetails = memo(function FinalSaleReturnDetails({
  stepSelect,
  state,
  setState,
}: StepTypeDetailsProps<FinalSaleReturnState>) {
  const { t } = useTranslation();
  const nextStepChange = useHandler((next: string | undefined) => {
    setState((state) => ({ ...state, next }));
  });

  return (
    <>
      <Text fontSize="xs" textColor="secondary">
        {t("Next step")}
      </Text>
      {!state.next && (
        <Text fontSize="xs" fontWeight="regular" textColor="error">
          {t("Required")}
        </Text>
      )}
      {stepSelect({ value: state.next, valueChange: nextStepChange })}
    </>
  );
});
